import React, { useState } from "react";
import {
  Dialog,
  Typography,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  ListItemIcon
} from "@material-ui/core";
import { useTranslation } from "../../langs/useTranslation";
import useStyles from "../../styles/deviceStyle";
import ArrowRightRoundedIcon from "@material-ui/icons/ArrowRightRounded";

const DeviceOwners = props => {
  const classes = useStyles();
  const { t } = useTranslation("device");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleDialogOpen = () => {
    setAnchorEl(true);
  };

  const handleDialogClose = () => {
    setAnchorEl(null);
  };

  const ifHasDialog = props.owners.length > 3;

  return (
    <div className={classes.deviceOwners}>
      {props.owners ? (
        <>
          {props.owners.map((owner, index) => {
            if (index < 3) {
              return (
                <Typography variant="body2" key={index}>
                  {owner}
                </Typography>
              );
            }
            return false;
          })}
          {ifHasDialog ? (
            <span
              className={classes.deviceOwnersBtn}
              onClick={handleDialogOpen}
            >
              more
            </span>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
      {ifHasDialog ? (
        <Dialog
          className={classes.deviceOwnersModal}
          open={open}
          onClose={handleDialogClose}
        >
          <DialogTitle>{t("category.allTheOwners")}</DialogTitle>
          <DialogContent>
            <List>
              {props.owners.map((owner, index) => {
                return (
                  <ListItem key={index}>
                    <ListItemIcon>
                      <ArrowRightRoundedIcon />
                    </ListItemIcon>
                    <ListItemText>
                      <Typography variant="body2">{owner}</Typography>
                    </ListItemText>
                  </ListItem>
                );
              })}
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        ""
      )}
    </div>
  );
};

export default DeviceOwners;
